var map = {
	"./featured-banner.de-CH.json": 1064,
	"./featured-banner.de-DE.json": 1065,
	"./featured-banner.en-CA.json": 1066,
	"./featured-banner.en-GB.json": 1067,
	"./featured-banner.en-IN.json": 1068,
	"./featured-banner.en-ME.json": 1069,
	"./featured-banner.en-US.json": 1070,
	"./featured-banner.es-EM.json": 1071,
	"./featured-banner.es-ES.json": 1072,
	"./featured-banner.fr-BE.json": 1073,
	"./featured-banner.fr-CA.json": 1074,
	"./featured-banner.fr-CH.json": 1075,
	"./featured-banner.nl-BE.json": 1076,
	"./featured-banner.nl-NL.json": 1077,
	"./featured-banner.pl-PL.json": 1078,
	"./featured-banner.pt-BR.json": 1079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1063;